/**
 * 环境变量配置
 */

import { APP_VERSION } from '@/constants/version';

/**
 * 获取环境变量值
 * @param key 环境变量键名
 * @param defaultValue 默认值
 * @returns 环境变量值
 */
export const getEnvValue = (key: string, defaultValue?: string): string => {
  return import.meta.env[key] || defaultValue || '';
};

// 应用基础配置
export const APP_CONFIG = {
  // 应用标题
  title: getEnvValue('VITE_APP_TITLE', 'Light X for Creative'),
  // 当前环境
  env: getEnvValue('VITE_APP_ENV', 'development'),
  // 是否为开发环境
  isDev: import.meta.env.DEV,
  // 是否为生产环境
  isProd: import.meta.env.PROD,
} as const;

// API 配置
export const API_CONFIG = {
  // API 基础地址
  baseURL: getEnvValue('VITE_API_BASE_URL', '/api'),
  // SSE 连接路径
  ssePath: getEnvValue('VITE_SSE_PATH', '/resource/sse'),
  // 请求超时时间
  timeout: 30000,
} as const;

export const TT_UPLOADER_APPID = getEnvValue('VITE_TT_UPLOADER_APPID');

// 功能开关配置
export const FEATURE_CONFIG = {
  // 是否启用调试模式
  enableDebug: getEnvValue('VITE_ENABLE_DEBUG') === 'true',
  // 是否开启ReactQueryDevtools
  enableReactQueryDevtools: getEnvValue('VITE_ENABLE_REACT_QUERY_DEVTOOLS') === 'true',
  // 是否开启性能分析
  enablePerfAnalysis: getEnvValue('VITE_ENABLE_PERF_ANALYSIS') === 'true',
} as const;

/**
 * 检查是否为开发环境
 */
export const isDevelopment = (): boolean => {
  return APP_CONFIG.env === 'development' || APP_CONFIG.isDev;
};

/**
 * 检查是否为生产环境
 */
export const isProduction = (): boolean => {
  return APP_CONFIG.env === 'production' || APP_CONFIG.isProd;
};

/**
 * 打印环境信息（仅在开发环境）
 */
export const printEnvInfo = (): void => {
  if (isDevelopment()) {
    console.log('🚀 应用环境信息:');
    console.log('📱 应用标题:', APP_CONFIG.title);
    console.log('📦 应用版本:', APP_VERSION);
    console.log('🌍 当前环境:', APP_CONFIG.env);
    console.log('🔗 API 地址:', API_CONFIG.baseURL);
    console.log('⚙️ 功能开关:', FEATURE_CONFIG);
  }
};
